'use client'

// Entry for `@mentora/feature-components/analytics`. Kept out of the main barrel
// so `instrumentation-client.ts`, which runs before hydration on every page,
// imports only this and not every shared screen. `'use client'` makes every
// export a client reference: the server-rendered footer and root layout mount
// the banner without the server ever evaluating posthog-js.
export { AnalyticsIdentity, type AnalyticsIdentityActions, type AnalyticsUser } from './analytics-identity'
export { acceptConsent, type ConsentStatus, rejectConsent, reopenConsent, resetAnalyticsIdentity } from './consent'
export { ConsentBanner } from './consent-banner'
export { CONSENT_STORAGE_KEY } from './consent-storage'
export { CookiePreferencesButton } from './cookie-preferences-button'
export { initAnalytics, SENSITIVE_SELECTORS } from './posthog-client'
export { useAnalytics } from './use-analytics'
export { useConsentStatus } from './use-consent-status'
export { useTrackOnce } from './use-track-once'
